<template>
	<div class="wrapper">
		<z-Header></z-Header>
		<div class="content">
			<router-view></router-view>
		</div>
	   	<z-Footer></z-Footer>
		<z-rightSidebar></z-rightSidebar>
	</div>
</template>

<script>
	export default{
		name: 'Layout',
		data () {
		    return {
		    
		    }
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/layout/index.vue